export default "__VITE_ASSET__ROja1Q_S__ 740w";